import { ReactElement } from 'react';
import {
  Tooltip as MuiTooltip,
  Typography,
  SxProps,
  useTheme
} from '@mui/material';

export type Props = {
  children: ReactElement;
  title: string | React.ReactNode;
  isOpen?: boolean;
};

const tooltipSx: SxProps = {
  backgroundColor: 'customGrey.light',
  color: 'customGrey.dark',
  borderRadius: '8px',
  border: '1px solid red',
  py: 1,
  px: '12px'
};

export const IconTooltip: React.FC<Props> = ({ children, title, isOpen }) => {
  const { palette } = useTheme();

  return (
    <MuiTooltip
      title={
        typeof title === 'string' ? (
          <Typography
            variant="body2"
            sx={{
              textAlign: 'center',
              wordWrap: 'normal',
              fontWeight: 500,
              fontSize: '12px',
              maxWidth: 140
            }}
          >
            {title}
          </Typography>
        ) : (
          title
        )
      }
      open={isOpen}
      placement="top"
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            ...tooltipSx,
            backgroundColor: palette.customGrey.light,
            color: palette.customGrey.dark,
            border: `1px solid ${palette.customGrey.medium}`
          }
        },
        arrow: {
          sx: {
            '&:before': {
              color: palette.customGrey.light,
              border: `1px solid ${palette.customGrey.medium}`
            }
          }
        }
      }}
    >
      {children}
    </MuiTooltip>
  );
};
